'use strict';

module.exports = {
	...require('./default'),
	...require('./cust'),
};